import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
  QuestionMarkCircleIcon
} from '@heroicons/react/24/outline'
import React from 'react'

interface NotificationIconProps {
  notification: { status?: string; [key: string]: unknown }
}

const NotificationIcon = ({ notification }: NotificationIconProps) => {
  if (notification.status === 'info') {
    return <div
      className="mx-auto shrink-0 flex items-center justify-center h-8 w-8 rounded-full bg-perfect-shine-200 sm:mx-0 sm:h-8 sm:w-8">
      <InformationCircleIcon className="h-6 w-6 text-perfect-shine-800" aria-hidden="true" />
    </div>
  } else if (notification.status === 'success') {
    return <div
      className="mx-auto shrink-0 flex items-center justify-center h-8 w-8 rounded-full bg-green-200 sm:mx-0 sm:h-8 sm:w-8">
      <CheckCircleIcon className="h-6 w-6 text-green-800" aria-hidden="true" />
    </div>
  } else if (notification.status === 'warn') {
    return <div
      className="mx-auto shrink-0 flex items-center justify-center h-8 w-8 rounded-full bg-anzac-light sm:mx-0 sm:h-8 sm:w-8">
      <ExclamationCircleIcon className="h-6 w-6 text-anzac" aria-hidden="true" />
    </div>
  } else {
    return <div
      className="mx-auto shrink-0 flex items-center justify-center h-8 w-8 rounded-full bg-gray-200 sm:mx-0 sm:h-8 sm:w-8">
      <QuestionMarkCircleIcon className="h-6 w-6 text-gray-800" aria-hidden="true" />
    </div>
  }
}

export default NotificationIcon
